<template>
  <div class="container">
    <slot></slot>
    <el-button
      type="primary"
      class="submit reset"
      @click="reset"
      v-show="showReset"
      >重置</el-button
    >
    <el-button type="primary" class="submit" @click="submit">查询</el-button>
  </div>
</template>

<script>
export default {
  props: {
    showReset: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    submit() {
      this.$emit('search');
    },
    reset() {
      this.$emit('reset');
    }
  }
};
</script>

<style lang="stylus" scoped>
.container
  background #fff
  padding 15px
  overflow hidden
  .submit
    float right
  .reset
    margin-left 10px
</style>
